import React, { useState } from 'react';
import { Button, KIND } from 'baseui/button';
import { Dialog } from 'baseui/dialog';
import { Textarea } from 'baseui/textarea';
export const COLLECT_COMMENT_DIALOG_CONSTANTS = {
  HEADING: 'Comment',
  CANCEL: 'Cancel',
  PLACEHOLDER: 'Please enter comment'
};
export type CollectCommentDialogPropsT = {
  isOpen: boolean;
  primaryButtonText?: string;
  onSubmit?: (comment: string) => void;
  onCancel?: () => void;
};
export function CollectCommentDialog(props: CollectCommentDialogPropsT) {
  const {
    isOpen = false,
    primaryButtonText,
    onSubmit,
    onCancel
  } = props;
  const [comment, setComment] = useState('');
  const [isSubmitPressed, setIsSubmitPressed] = useState(false);
  const isError = isSubmitPressed && comment.trim().length === 0;
  const handleClose = () => {
    setComment('');
    setIsSubmitPressed(false);
  };
  const handleSubmit = () => {
    setIsSubmitPressed(true);
    const trimmedComment = comment.trim();
    const isCommentValid = trimmedComment.length > 0;
    if (isCommentValid) {
      handleClose();
      onSubmit?.(trimmedComment);
    }
  };
  const handleCancel = () => {
    handleClose();
    onCancel?.();
  };
  return <Dialog overrides={{
    Body: {
      style: {
        marginBottom: 0
      }
    }
  }} isOpen={isOpen} showDismissButton onDismiss={handleCancel} heading={COLLECT_COMMENT_DIALOG_CONSTANTS.HEADING} buttonDock={{
    primaryAction: <Button kind={KIND.primary} onClick={handleSubmit}>
            {primaryButtonText}
          </Button>,
    secondaryActions: [<Button key="secondary" kind={KIND.secondary} onClick={handleCancel}>
            {COLLECT_COMMENT_DIALOG_CONSTANTS.CANCEL}
          </Button>]
  }}>
      <Textarea id="comment-textarea" role="textbox" placeholder={COLLECT_COMMENT_DIALOG_CONSTANTS.PLACEHOLDER} value={comment} onChange={e => setComment(e.target.value)} error={isError} />
    </Dialog>;
}